export const config = {
  token: null
}